import { Routes, Route } from "react-router-dom";
import Login from "../../pages/loginPage";
import HomePage from "../../pages/homePage";
import { AdminOnlyRoute, ProtectedRoute } from "../../auth/ProtectedRoute";
import ProfilePage from "../../pages/ProfilePage";
import SignUpPage from "../../pages/signupPage";
import UpdateProfilePage from "../../pages/UpdateProfilePage";
import StorePage from "../../pages/StorePage";
import CreateStorePage from "../../pages/CreateStorePage";
import InventoriesPage from "../../pages/InventoriesPage";
import InventoryByIdPage from "../../pages/InventoryByIdPage";
import StoresPage from "../../pages/StoresPage";
import UpateStorePage from "../../pages/UpdateStorePage";
import CreateInventoryPage from "../../pages/CreateInventoryPage";
import WarehousesPage from "../../pages/WarehousesPage";
import WarehousePage from "../../pages/WarehousePage";
import CreateWarehousePage from "../../pages/CreateWarehousePage";
import InstagramConnectPage from "../../components/Instagram/InstagramConnect";
import UpdateWarehousePage from "../../pages/UpdateStorePage";
import LogOutPage from "../../pages/LogOutPage";
import UpdateInventoryPage from "../../pages/UpdateInventoryPage";
const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/register" element={<SignUpPage />} />
      <Route path="/logout" element={<LogOutPage />}></Route>
      {/* All protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/create-store" element={<CreateStorePage />}></Route>
        <Route path="/stores" element={<StoresPage />}></Route>
        <Route path="/store/:id" element={<StorePage />}></Route>
        <Route path="/update-store/:id" element={<UpateStorePage />}></Route>
        <Route path="/inventory" element={<InventoriesPage />}></Route>
        <Route
          path="/create-inventory"
          element={<CreateInventoryPage />}
        ></Route>
        <Route path="/inventory/:id" element={<InventoryByIdPage />}></Route>
        <Route path="/warehouses" element={<WarehousesPage />}></Route>
        <Route
          path="/create-warehouse"
          element={<CreateWarehousePage />}
        ></Route>
        <Route path="/warehouse/:id" element={<WarehousePage />}></Route>
        <Route
          path="/update-warehouse/:id"
          element={<UpdateWarehousePage />}
        ></Route>
        <Route
          path="/update-inventory/:id"
          element={<UpdateInventoryPage />}
        ></Route>
        <Route
          path="/instagram/connect/*"
          element={<InstagramConnectPage />}
        ></Route>

        {/* All admin-only routes */}
        <Route element={<AdminOnlyRoute />}>
          <Route
            path="/update-profile/:id"
            element={<UpdateProfilePage />}
          ></Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
